import React, { Component } from "react";
import { connect } from "react-redux";
import { viewOffer } from "../../actions";
import { formatCurrency, intFormat } from "./../../../../js/shared/utils";
import { OfferStatus, OfferColorStatus, OfferInfo } from "./../../shared/enums";
import { NavLink } from "react-router-dom";

class ViewOffer extends Component {
	constructor() {
		super();
		this.state = {};

		this.backEdit = this.backEdit.bind(this);
	}

	backEdit() {
		const { viewOffer } = this.props;
		window.scrollTo(0, 0);
		viewOffer(undefined);
	}

	render() {
		const { offerViewing: offer } = this.props;

		if (!offer) {
			return <Loading label="Carregando oferta" />;
		}

		return (
			<section className="view-offer row">
				<div className="col-xs-16 view-offer--title">
					<div className="v-center-columns">
						<i className="icon-arrow-down rotate-to-left" onClick={this.backEdit} />
					</div>
					<div className="col-xs-10 v-center-columns">
						<p>Detalhes</p> <strong>Oferta {offer.fidelity.name}</strong>
					</div>
				</div>
				<div className="col-xs-16 view-offer--status">
					<p className="no-margin">
						<i className={`dot dot-${OfferColorStatus[offer.status]}`} />
						<strong>Sua oferta está {OfferStatus[offer.status].toLowerCase()}</strong>
					</p>
				</div>
				<div className="col-xs-16 view-offer--info">
					<p>{OfferInfo[offer.status]}</p>
				</div>
				<div className="col-xs-16">
					<div
						className={`col-xs-16 view-offer--box view-offer--box-${
							OfferColorStatus[offer.status]
						}`}
					>
						<p className={`offer-status offer-status-${OfferColorStatus[offer.status]}`}>
							<strong>{OfferStatus[offer.status]}</strong>
						</p>
						<p className="text-total">Valor a receber caso venda todas as milhas</p>
						<p className="value-total">
							<strong>{formatCurrency(offer.total)}</strong>
						</p>
						<div className="col-xs-16 offers-divider" />
						<p className="quantity-miles">{intFormat(offer.quant)} milhas</p>
						<p className="thousand-price">{formatCurrency(offer.price)} a cada 1.000 milhas</p>
					</div>
				</div>
				{offer.status !== 2 && (
					<div className="offers-home--new row">
						<div className="col-xs-16 button">
							<div className="col-xs-16">
								<NavLink className="btn btn-success" to="#">
									Editar oferta
								</NavLink>
							</div>
						</div>
					</div>
				)}
			</section>
		);
	}
}

const mapStateToProps = state => ({
	offerViewing: state.offers.offerViewing
});

const mapDispatchToProps = dispatch => {
	return {
		viewOffer: offer => dispatch(viewOffer(offer))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewOffer);
